import { render, staticRenderFns } from "./inventory.vue?vue&type=template&id=61153538&"
import script from "./inventory.js?vue&type=script&lang=js&"
export * from "./inventory.js?vue&type=script&lang=js&"
import style0 from "./inventory.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports